import svgaUpgrade from '@/assets/svga/upgrade.svga';
import svgaUpgradeBtn from '@/assets/svga/upgrade-btn.svga';
import svgaMagicWeapon from '@/assets/svga/magic-weapon.svga';

// 升级资源
export const upgradeResourceList = [svgaUpgrade, svgaUpgradeBtn];

// 法宝资源
export const magicWeaponResourceList = [svgaMagicWeapon];

export const firstLoadResourceList = [];
